import React from 'react'
import amplifyConfig from '../amplify_config'

import googleButtonImg from '../images/btn_google_signin_dark_normal_web.png'
import googleButtonImg2x from '../images/btn_google_signin_dark_normal_web@2x.png'

const SocialLoginButtons = () => {
  const config = amplifyConfig.Auth
  const {
    domain,
    redirectSignIn,
    responseType,
  } = config.oauth

  const clientId = config.userPoolWebClientId
  const urlToFacebook =
    `https://${domain}/oauth2/authorize?redirect_uri=${redirectSignIn}&response_type=${responseType}&client_id=${clientId}&identity_provider=Facebook`
  const urlToGoogle =
    `https://${domain}/oauth2/authorize?redirect_uri=${redirectSignIn}&response_type=${responseType}&client_id=${clientId}&identity_provider=Google`

  return (
    <div className="mb-3 mt-1">
      <div className="text-center">
        <a href={urlToFacebook} className="btn btn-facebook">Continue with Facebook</a>
      </div>
      <div className="mt-1 text-center">
        <a href={urlToGoogle}>
          <img
            alt='Sign in with Google'
            src={googleButtonImg}
            srcSet={`
              ${googleButtonImg} 1x,
              ${googleButtonImg2x} 2x
            `}
          />
        </a>
      </div>
    </div>
  )
}

export default SocialLoginButtons
